module.exports = __webpack_public_path__ + "img/home1.cc4a71d2.png";